import Plot from 'features/plotly'
import { Shape } from 'plotly.js'
import React, { FC } from 'react'
import styled from 'styled-components'

import { WATERFALL_COLOR_SCALE } from './waterfallColorscale'

const CenteredDiv = styled.div`
  max-width: fit-content;
  margin-left: auto;
  margin-right: auto;
`

type WaterfallPlotProps = {
  dataValues?: number[][]
  isDScan?: boolean
  minCoord?: number
  shapes?: Partial<Shape>[]
  width?: number
  height?: number
}

function rotate(arr: number[][]) {
  const newArr: number[][] = []

  const xLen = arr.at(0)?.length
  if (!xLen) {
    return []
  }
  for (let xIndex = 0; xIndex < xLen; xIndex++) {
    const newRow: number[] = []
    arr.forEach((_, yIndex) => {
      newRow.push(arr[yIndex][xIndex])
    })
    newArr.push(newRow)
  }
  return newArr
}

function flipY(arr: number[][]) {
  const newArr: number[][] = []
  const yLen = arr.length
  for (let flippedYindex = yLen - 1; flippedYindex >= 0; flippedYindex--) {
    const newRow: number[] = []
    arr[flippedYindex].forEach((val) => {
      newRow.push(val)
    })
    newArr.push(newRow)
  }

  return newArr
}

function removeNegatives(arr: number[][]) {
  return arr.map((xs) => xs.map((value) => (value < 0 ? 0 : value)))
}

const WaterfallPlot: FC<WaterfallPlotProps> = (props: WaterfallPlotProps) => {
  const { width, height, dataValues, isDScan, shapes } = props

  // Configuration for the heatmap
  const config = {
    displayModeBar: false,
    responsive: true,
  }

  const formattedData = React.useMemo(() => {
    if (isDScan) {
      return dataValues
    } else {
      return removeNegatives(flipY(rotate(dataValues ?? [])))
    }
  }, [dataValues, isDScan])

  return dataValues ? (
    <CenteredDiv>
      <Plot
        data={[
          {
            z: formattedData,
            type: 'heatmap',
            colorscale: WATERFALL_COLOR_SCALE, // Choose a color scale
            showscale: false, // Show the color scale
            reversescale: false, // Reverse the color scale if needed
            hoverinfo: 'x+y+z', // Show x, y, and z values on hover
          },
        ]}
        layout={{
          margin: { t: 0, b: 0, l: 0, r: 0 },
          width: width ?? 350,
          height: height ?? 350,
          shapes: shapes ?? [],
          xaxis: {
            showticklabels: false, // Hide the tick labels
            ticks: '', // Remove the tick marks
            zeroline: false, // Remove the zero line
            showline: false, // Remove the axis line
          },
          yaxis: {
            showticklabels: false, // Hide the tick labels
            ticks: '', // Remove the tick marks
            zeroline: false, // Remove the zero line
            showline: false, // Remove the axis line
          },
          plot_bgcolor: 'rgba(0, 0, 0, 0)', // Set background to transparent or a specific color
          paper_bgcolor: 'rgba(0, 0, 0, 0)', // Set backgr
        }}
        config={config}
      />
    </CenteredDiv>
  ) : (
    <div />
  )
}

export default WaterfallPlot
